export default "__VITE_ASSET__B36gparN__"